// **************************************************
// Share
// **************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  document.querySelectorAll('.mod-share__icon').forEach((share) => {
    share.addEventListener('click', () => {
      share.closest('.mod-share').classList.toggle('is-active');
    });
  });
});
